// AUTO-GENERATED by `python manage.py export_platform_events`. DO NOT EDIT.
// Source of truth: chalktalk/apps/platformevents/registry.py
// Contains ONLY client-emittable event types. This map is the single
// source: the PlatformEventType union is derived from its values in
// utils/platformEvents.ts, and call sites reference PLATFORM_EVENT_TYPES.*
/* eslint-disable import/prefer-default-export */

export const PLATFORM_EVENT_TYPES = {
  BELLRINGER_LAUNCHED: 'bellringer_launched',
  GROUP_ACTIVITY_REVIEWED: 'group_activity_reviewed',
  PRACTICE_REVIEWED: 'practice_reviewed',
  STUDYHALL_RESOURCE_VIEWED: 'studyhall_resource_viewed',
  WORKSHEET_DOWNLOADED: 'worksheet_downloaded',
} as const;
